var _a;
export var LoopMode;
(function (LoopMode) {
    LoopMode[LoopMode["Timer"] = 0] = "Timer";
    LoopMode[LoopMode["RAF"] = 1] = "RAF";
})(LoopMode || (LoopMode = {}));
var LoopRunnerPair = (_a = {},
    _a[LoopMode.RAF] = [window.requestAnimationFrame.bind(window), window.cancelAnimationFrame.bind(window)],
    _a[LoopMode.Timer] = [window.setTimeout.bind(window), window.clearTimeout.bind(window)],
    _a);
var TaskLoop = /** @class */ (function () {
    function TaskLoop(callback, mode) {
        this.running = false;
        this.callback = callback;
        if (mode === LoopMode.RAF && LoopRunnerPair[mode][0]) {
            this.mode = LoopMode.RAF;
        }
        else {
            this.mode = LoopMode.Timer;
        }
        this.runner = LoopRunnerPair[this.mode][0];
    }
    TaskLoop.prototype.start = function (interval) {
        var _this = this;
        if (interval === void 0) { interval = 0; }
        if (this.running)
            return;
        this.running = true;
        var loop = function () {
            var _a;
            if (!_this.running) {
                return;
            }
            (_a = _this.callback) === null || _a === void 0 ? void 0 : _a.call(_this);
            _this.loopId = _this.runner(loop, interval);
        };
        this.loopId = this.runner(loop, interval);
    };
    TaskLoop.prototype.stop = function () {
        if (!this.running)
            return;
        this.running = false;
        if (this.loopId)
            LoopRunnerPair[this.mode][1](this.loopId);
        this.loopId = null;
    };
    TaskLoop.prototype.destroy = function () {
        this.stop();
        this.callback = null;
        this.loopId = null;
    };
    return TaskLoop;
}());
export { TaskLoop };
;
